import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseEmbedconfigDto } from '../dto/powerbi/response.embedconfig.dto';
import { RequestFiltersContarDatos } from '../dto/powerbi/request.filters.contardatos.dto';
import { DAXQueryDto } from '../dto/powerbi/dax.query.dto';
import { timeout } from 'rxjs/operators';
import { Constants } from '../constants/constants';
import { DescargarBaseDatos } from '../dto/powerbi/descargar-base-datos.dto';
import { SlicerDto } from '../dto/powerbi/slicer.dto';

@Injectable({
  providedIn: 'root',
})
export class PowerbiService {
  private apiUrl = `${environment.apiUrl}/powerbi`;
  private downloadApiUrl = `${environment.downloadApiUrl}/api`;

  constructor(private http: HttpClient) {}

  getReporte(entidad: string): Observable<ResponseEmbedconfigDto> {
    return this.http.get<ResponseEmbedconfigDto>(
      `${this.apiUrl}/reporte/${entidad}`
    );
  }

  exportExcel(
    requestExportExcel: RequestFiltersContarDatos[],
    entidad: string
  ): Observable<Blob> {
    return this.http
      .post(`${this.apiUrl}/contardatos/${entidad}`, requestExportExcel, {
        responseType: 'blob',
      })
      .pipe(timeout(Constants.DESCARGA_TIMEOUT));
  }

  exportRespuestasEncuesta(
    requestExportExcel: RequestFiltersContarDatos[]
  ): Observable<Blob> {
    return this.http
      .post(`${this.apiUrl}/respuestasencuesta`, requestExportExcel, {
        responseType: 'blob',
      })
      .pipe(timeout(Constants.DESCARGA_TIMEOUT));
  }

  exportDB(query: DescargarBaseDatos): Observable<any> {
    return this.http.post(`${this.downloadApiUrl}/generar-excel/`, query);
  }

  downloadFile(reportId: string): Observable<Blob> {
    return this.http.post(
      `${this.downloadApiUrl}/descargar-documento/`,
      {
        id_documento: reportId
      },
      {
        responseType: 'blob',
      }
    );
  }

  downloadStatus(reportId: string): Observable<any> {
    return this.http.post(
      `${this.downloadApiUrl}/descargar-status/`,
      {
        id_documento: reportId,
      }
    );
  }

  exportPDF(
    requestExportPDF: RequestFiltersContarDatos[],
    tablero: string
  ): Observable<Blob> {
    return this.http.post(`${this.apiUrl}/cnt/${tablero}`, requestExportPDF, {
      responseType: 'blob',
    });
  }

  getViewBag(query: DAXQueryDto): Observable<any> {
    return this.http.post(`${this.apiUrl}/query/`, query);
  }
}
